document.addEventListener('DOMContentLoaded', function() {
    console.log('DOMContentLoaded');
});